import { useEffect, useMemo, useState } from 'react';

import { STORAGE_USER_INFO } from '@/resources/constants';

import LocalStorage from '@/utils/LocalStorage';

import { ApiMe } from '@/services/auth/auth.types';
import { useGetMeQuery } from '@/services/auth/auth';

const useAuthorization = () => {
  const [isFirstRender, setFirstRenderState] = useState(true);
  const { data, isError, isLoading } = useGetMeQuery();

  useEffect(() => {
    if (isLoading) return;
    if (!isFirstRender) return;

    if (!data || isError) {
      LocalStorage.delete(STORAGE_USER_INFO);
    } else {
      LocalStorage.set(STORAGE_USER_INFO, data);
    }

    setFirstRenderState(false);
  }, [data, isLoading, isError, isFirstRender]);

  return useMemo(() => {
    if (isFirstRender && !data) {
      const storageData = LocalStorage.get<ApiMe>(STORAGE_USER_INFO);

      return {
        isLoading,
        userInfo: storageData,
        isAuthorized: Boolean(storageData),
      };
    }

    return {
      isLoading,
      userInfo: isError ? undefined : data,
      isAuthorized: Boolean(isError ? false : data),
    };
  }, [data, isError, isFirstRender, isLoading]);
};

export default useAuthorization;
